import { FC } from 'react'
import { IProjectCheckpointInstance } from 'screens/Admin/ProjectCheckpoints/projectCheckpoints.types'
import Card from 'shared/Cards/Card'
import styles from './ProjectCheckpointCard.module.css'
import { useNavigate } from 'react-router-dom'
import Grade from 'shared/Grade'

interface ProjectCheckpointCardProps {
  checkpointInstance: IProjectCheckpointInstance
  index: number
}

const ProjectCheckpointPreviewCard: FC<ProjectCheckpointCardProps> = (props) => {
  const navigate = useNavigate()
  const { checkpointInstance } = props

  const handleClickCard = () => {
    navigate(`/project-checkpoints/${checkpointInstance.id}`)
  }

  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  }

  const grade = checkpointInstance.inspectionResult?.grade

  return (
    <Card type='normal' onClick={handleClickCard} style={{ cursor: 'pointer' }}>
      <div className='flex-lines'>
        <div className={styles.index}>
          <p className='text--body-s text--bold'>{props.index + 1}</p>
        </div>
        <p className='text--caption-l text--bold' style={{ letterSpacing: 'normal' }}>
          {checkpointInstance.name}
        </p>
        <p className='text--body-m text--secondary'>Дата окончания: {formatDate(checkpointInstance.endsAt)}</p>
        <p className='text--body-m text--secondary'>Этап: {checkpointInstance.stage.name}</p>
        <div className='flex-space-between'>
          <Grade grade={grade} />
        </div>
      </div>
    </Card>
  )
}

export default ProjectCheckpointPreviewCard
